import { store$, store } from "@redux/store";
import { routingStateActions } from 'features/routing';
import { LocationType, selectRectangularAreaLocation, selectLocationType } from "features/searchResultsFacets";
import { distinctUntilChanged, filter, map, skip } from "rxjs";
import { getMapCoordinatesQueryString } from "../services/pageUrlBuilder";

/**
 * This function updates the URL search query string with new map coordinates and sets the location as
 * "/map".
 * @param locationParameters - Has the location searchParameters property that provides the coordinates
 * used on the search to retrieve the listings based on the current search within map.
 */
const updateUrlSearchWithinMapQueryString = (locationParameters) => {

  const newUrlCoordinatesQueryString = getMapCoordinatesQueryString(locationParameters);

  store.dispatch(routingStateActions.updateRectangularSearchQueryString(newUrlCoordinatesQueryString));
}

/**
 * This function removes the search within map query string from the routing state.
 */
const removeUrlSearchWithinMapQueryString = () => {

  store.dispatch(routingStateActions.updateRectangularSearchQueryString(''));
}

/* This code is setting up a subscription to the `store$` observable, which emits the current state of
the Redux store. The subscription is using a series of operators to filter, map, and transform the
emitted values before passing them to the `updateUrlSearchWithinMapQueryString` function. */
store$
.pipe(
  map(selectRectangularAreaLocation),
  filter(Boolean),
  distinctUntilChanged((a, b) =>
    a.minimumLatitude  === b.minimumLatitude  &&
    a.maximumLatitude  === b.maximumLatitude  &&
    a.minimumLongitude === b.minimumLongitude &&
    a.maximumLongitude === b.maximumLongitude
  ),
)
.subscribe(updateUrlSearchWithinMapQueryString);

/* This code sets up a subscription to the `store$` observable, which emits the current state of the
Redux store. The subscription uses a series of operators to filter, map, and transform the emitted
values before passing them to the `removeUrlSearchWithinMapQueryString` function. */
store$.pipe(
  map(selectLocationType),
  distinctUntilChanged(),
  skip(1),
  filter((locationType) => locationType !== LocationType.RectangularArea.toString())
)
.subscribe(removeUrlSearchWithinMapQueryString);